import React, { useEffect, useState } from "react";
import { Row, Col, Input, Select, Button, AutoComplete, Checkbox, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { v4 } from "uuid";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useDispatch } from "react-redux";
import CloseIcon from "../../../../../assets/icons/close-icon.svg";

import { resetGroupBuilders, updateAggGroupBuilders } from "../../../../../redux/editorSlice";

const { Option } = Select;

export default function GroupingEditor(props) {
  const dispatch = useDispatch();
  const { availableFields, aggGroupBuilders } = props;

  const [isAdvanced, setIsAdvanced] = useState(false);
  const [fieldNames, setFieldNames] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tempRow, setTempRow] = useState({ value: "" });
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [tempColumn, setTempColumn] = useState({ value: "" });
  const [selectedValues, setSelectedValues] = useState([]);
  const [tempValue, setTempValue] = useState({ value: "" });
  const [builders, setBuilders] = useState({
    id: v4(),
    isGrouping: true,
    operator: "none",
    fieldNamesList: [],
    sumFieldNamesList: [],
    displayFieldNamesList: [],
    uniqueFieldNamesList: [],
    advanced: isAdvanced,
  });

  useEffect(() => {
    setFieldNames(
      availableFields.map((af) => {
        return {
          ...af,
          value: af.fieldName,
        };
      }),
    );
    console.log("Available Field NAmes=====>>", availableFields);
  }, [availableFields]);

  useEffect(() => {
    if (
      aggGroupBuilders &&
      aggGroupBuilders.selectedRows &&
      aggGroupBuilders.selectedColumns &&
      aggGroupBuilders.selectedValues
    ) {
      setIsAdvanced(aggGroupBuilders.advanced);
      setSelectedRows(aggGroupBuilders.selectedRows);
      setSelectedColumns(aggGroupBuilders.selectedColumns);
      setSelectedValues(aggGroupBuilders.selectedValues);
    }
  }, [aggGroupBuilders]);

  useEffect(() => {
    let availableFieldNames = availableFields
      .map((af) => {
        return { ...af, value: af.fieldName };
      })
      .filter(
        (a) =>
          selectedRows.indexOf((x) => x.fieldName !== a.fieldName) &&
          selectedColumns.indexOf((y) => y.fieldName !== a.fieldName),
      );
    console.log("availableFieldNames ======>>>>>", availableFieldNames);
  }, [fieldNames, selectedRows, selectedColumns, availableFields]);

  const handleOnDragEnd = (result) => {
    console.log("DRAG RESULTS===>>>", result);
    if (!result.destination) return;
  };

  //   const handleAddRow = () => {
  //     if (selectedRows.findIndex((x) => x.value === tempRow.value) === -1 && tempRow.value !== "") {
  //       setSelectedRows([
  //         ...selectedRows,
  //         ...[Object.assign(tempRow, { config: { orderBy: "ASC", sortBy: "", showTotals: false } })],
  //       ]);
  //     }
  //     setTempRow({ value: "" });
  //   };

  //   const handleAddColumn = () => {
  //     if (selectedColumns.findIndex((x) => x.value === tempRow.value) === -1 && tempColumn.value !== "") {
  //       setSelectedColumns([
  //         ...selectedColumns,
  //         ...[Object.assign(tempColumn, { config: { orderBy: "ASC", sortBy: "", showTotals: false } })],
  //       ]);
  //     }
  //     setTempRow({ value: "" });
  //   };

  //   const handleAddValue = () => {
  //     if (selectedValues.findIndex((x) => x.value === tempValue.value) === -1 && tempValue.value !== "") {
  //       setSelectedValues([...[Object.assign(tempValue, { config: { func: "sum", showas: "value" } })]]);
  //     }
  //     setTempRow({ value: "" });
  //   };

  /* The Select hands back an antd option ({value, key, children}) which carries no
     fieldName, but everything downstream - fieldNamesList, sumFieldNamesList,
     displayFieldNamesList - is keyed on fieldName. Without it the grouping config was
     built out of undefined values and silently produced nothing. */
  const withFieldName = (option) => ({ ...option, fieldName: option?.fieldName ?? option?.value });

  const handleAddRow = () => {
    if (selectedRows.findIndex((x) => x.value === tempRow.value) === -1 && tempRow.value !== "") {
      setSelectedRows([
        ...selectedRows,
        Object.assign(withFieldName(tempRow), { config: { orderBy: "ASC", sortBy: "", showTotals: false } }),
      ]);
    }
    setTempRow({ value: "" });
  };

  const handleAddColumn = () => {
    if (selectedColumns.findIndex((x) => x.value === tempColumn.value) === -1 && tempColumn.value !== "") {
      setSelectedColumns([
        ...selectedColumns,
        Object.assign(withFieldName(tempColumn), { config: { orderBy: "ASC", sortBy: "", showTotals: false } }),
      ]);
    }
    setTempColumn({ value: "" });
  };

  const handleAddValue = () => {
    if (selectedValues.findIndex((x) => x.value === tempValue.value) === -1 && tempValue.value !== "") {
      setSelectedValues([
        ...selectedValues,
        Object.assign(withFieldName(tempValue), { config: { func: "sum", showas: "value" } }),
      ]);
    }
    setTempValue({ value: "" });
  };

  /* Rows = the group-by keys, Columns = the fields that get aggregated
     (sumFieldNamesList). Advanced also needs a Value, which is the measure the pivot
     spreads across the column headers. Anything less produces a table with no values,
     so Apply stays disabled - the same rule the previous editor enforced. */
  const canApplyGrouping =
    selectedRows.length > 0 && selectedColumns.length > 0 && (!isAdvanced || selectedValues.length > 0);

  const applyHint = !selectedRows.length
    ? "Add at least one Row to group by"
    : !selectedColumns.length
      ? "Add at least one Column to aggregate"
      : "Add a Value for the advanced pivot";

  const HandleApplyGrouping = () => {
    if (!canApplyGrouping) {
      message.warning(applyHint);
      return;
    }

    // both modes produce the same shape - only the `advanced` flag differs
    const groupings = {
      id: v4(),
      isGrouping: true,
      operator: "none",
      fieldNamesList: selectedRows.map((x) => x.fieldName),
      selectedRows: selectedRows,
      selectedColumns: selectedColumns,
      selectedValues: selectedValues,
      sumFieldNamesList: selectedColumns.map((y) => y.fieldName),
      displayFieldNamesList: [...selectedRows.map((x) => x.fieldName), ...selectedColumns.map((y) => y.fieldName)],
      uniqueFieldNamesList: selectedRows.map((x) => x.fieldName),
      advanced: isAdvanced,
    };
    dispatch(updateAggGroupBuilders(groupings));
    message.success("Grouping applied");
  };

  const removeRow = (r) => {
    setSelectedRows(selectedRows.filter((sr) => sr.value !== r.value));
  };

  const removeColumn = (c) => {
    setSelectedColumns(selectedColumns.filter((sr) => sr.value !== c.value));
  };

  const removeValue = (v) => {
    setSelectedValues(selectedValues.filter((sv) => sv.value !== v.value));
  };

  const resetBuilders = () => {
    setSelectedRows([]);
    setSelectedColumns([]);
    setTempColumn({ value: "" });
    setTempRow({ value: "" });
    dispatch(resetGroupBuilders());
  };

  const onChangeAdvancedGrouping = (e) => {
    setIsAdvanced(e.target.checked);
  };

  const handleChngeRowOrderby = (index, obj, val) => {
    setSelectedRows(
      selectedRows.map((sr, i) => {
        return {
          ...sr,
          config: {
            orderBy: index === i ? val : sr.config.orderBy,
            sortBy: sr.config.sortBy,
            showTotals: sr.checked.showTotals,
          },
        };
      }),
    );
  };

  const handleChngeRowSortby = (index, obj, val) => {
    setSelectedRows(
      selectedRows.map((sr, i) => {
        return {
          ...sr,
          config: {
            orderBy: sr.config.orderBy,
            sortBy: index === i ? val : sr.config.sortBy,
            showTotals: sr.checked.showTotals,
          },
        };
      }),
    );
  };

  const onChangeShowRowTotals = (index, obj, val) => {
    setSelectedRows(
      selectedRows.map((sr, i) => {
        return {
          ...sr,
          config: {
            orderBy: sr.config.orderBy,
            sortBy: sr.config.sortBy,
            showTotals: index === i ? val : sr.checked.showTotals,
          },
        };
      }),
    );
  };
  const handleChngeColumnOrderby = (index, obj, val) => {
    setSelectedColumns(
      selectedColumns.map((sr, i) => {
        return {
          ...sr,
          config: {
            orderBy: index === i ? val : sr.config.orderBy,
            sortBy: sr.config.sortBy,
            showTotals: sr.config.showTotals,
          },
        };
      }),
    );
  };

  const handleChngeColumnSortby = (index, obj, val) => {
    setSelectedColumns(
      selectedColumns.map((sr, i) => {
        return {
          ...sr,
          config: {
            orderBy: sr.config.orderBy,
            sortBy: index === i ? val : sr.config.sortBy,
            showTotals: sr.config.showTotals,
          },
        };
      }),
    );
  };

  const onChangeShowColumnTotals = (index, obj, val) => {
    setSelectedColumns(
      selectedColumns.map((sr, i) => {
        return {
          ...sr,
          config: {
            orderBy: sr.config.orderBy,
            sortBy: sr.config.sortBy,
            showTotals: index === i ? val : sr.checked.showTotals,
          },
        };
      }),
    );
  };

  const handleChangeGroupFunc = (val, index) => {
    setSelectedValues(
      selectedValues.map((sv, i) => {
        return {
          ...sv,
          config: {
            func: val,
            showas: sv.config.showas,
          },
        };
      }),
    );
  };

  const handleChangeGroupShowAs = (val, index) => {
    setSelectedValues(
      selectedValues.map((sv, i) => {
        return {
          ...sv,
          config: {
            func: sv.config.func,
            showas: val,
          },
        };
      }),
    );
  };

  console.log("selectedRows", selectedRows);

  // return (
  //     <div style={{ marginBottom: '24px' }}>
  //         <div style={{ display: 'flex', justifyContent: 'space-between' }}>
  //             <div>
  //                 <Checkbox onChange={onChangeAdvancedGrouping} checked={isAdvanced}>Advanced Grouping</Checkbox>
  //             </div>
  //             <div>
  //                 {selectedColumns.length > 0 && selectedRows.length > 0 ?
  //                     <>
  //                         <Button onClick={HandleApplyGrouping}>Apply</Button>
  //                         &nbsp;
  //                         <Button onClick={resetBuilders}>Reset</Button>
  //                     </>
  //                     : null}
  //             </div>
  //         </div>
  //         <Row gutter={16}>
  //             <Col span={8}>
  //                 <div style={{ border: '1px solid #aaa' }}>
  //                     <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', alignItems: 'center' }}>
  //                         <div>Rows</div>
  //                         <div>
  //                             <AutoComplete
  //                                 // value={tempRow.value || ''}
  //                                 options={fieldNames}
  //                                 filterOption={(inputValue, option) =>
  //                                     option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
  //                                 }
  //                                 style={{
  //                                     width: 140,
  //                                 }}
  //                                 onChange={(value) => { console.log("VAL+++>>", value) }}
  //                                 onSelect={(value, option) => { setTempRow(option) }}
  //                                 placeholder="Rows"
  //                             />
  //                         </div>
  //                         <Button onClick={handleAddRow}>Add</Button>

  //                     </div>
  //                     {selectedRows.map((sr, i) => (
  //                         <div style={{ margin: '8px', border: '1px solid #bbb' }} key={`sr_${i}`}>
  //                             <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', allignItems: 'baseline' }}>
  //                                 <div>
  //                                     <b>{sr.fieldName}</b>
  //                                 </div>
  //                                 <div><Button type="link" icon={<CloseOutlined />} danger size="small" onClick={() => removeRow(sr)}></Button></div>
  //                             </div>
  //                             {isAdvanced ?
  //                                 <div>
  //                                     <div style={{ display: 'flex', padding: '8px', justifyContent: 'space-between' }}>
  //                                         <div>
  //                                             <div>
  //                                                 <label>Order By</label>
  //                                             </div>
  //                                             <div>
  //                                                 <Select style={{ minWidth: '100px' }} value={sr.config.orderBy} onChange={(val) => { handleChngeRowOrderby(i, sr, val) }}>
  //                                                     <Option>ASC</Option>
  //                                                     <Option>DESC</Option>
  //                                                 </Select>
  //                                             </div>
  //                                         </div>
  //                                         <div>
  //                                             <div>
  //                                                 <label>Sort By</label>
  //                                             </div>
  //                                             <div>
  //                                                 <Select style={{ minWidth: '100px' }} onChange={(val) => { handleChngeRowSortby(i, sr, val) }}>
  //                                                     {fieldNames.map(f => (
  //                                                         <Option value={f.fieldName}>{f.fieldName}</Option>
  //                                                     ))}
  //                                                 </Select>
  //                                             </div>
  //                                         </div>
  //                                     </div>
  //                                     <div style={{padding:'8px'}}>
  //                                         <Checkbox onChange={(e) =>onChangeShowRowTotals(i, sr, e.target.checked)} checked={sr.config.showTotals}>ShowTotal</Checkbox>
  //                                     </div>
  //                                 </div> : null}

  //                         </div>

  //                     ))}

  //                 </div>
  //             </Col>

  //             <Col span={8}>
  //                 <div style={{ border: '1px solid #aaa' }}>
  //                     <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', alignItems: 'center' }}>
  //                         <div>Column</div>
  //                         <div>
  //                             <AutoComplete
  //                                 // value={tempColumn.value || ''}
  //                                 options={isAdvanced?fieldNames:fieldNames.filter(f => f.dataType === 'number')}
  //                                 filterOption={(inputValue, option) =>
  //                                     option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
  //                                 }
  //                                 style={{
  //                                     width: 140,
  //                                 }}
  //                                 onChange={(value) => { console.log("VAL+++>>", value) }}
  //                                 onSelect={(value, option) => { setTempColumn(option) }}
  //                                 placeholder="Columns"
  //                             />
  //                         </div>
  //                         <Button onClick={handleAddColumn}>Add</Button>

  //                     </div>
  //                     {selectedColumns.map((sr, i) => (

  //                         <div style={{ margin: '8px', border: '1px solid #bbb' }} key={`sc_${i}`}>
  //                             <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', allignItems: 'baseline' }}>
  //                                 <div>
  //                                     <b>{sr.fieldName}</b>
  //                                 </div>
  //                                 <div><Button type="link" icon={<CloseOutlined />} danger size="small" onClick={() => removeColumn(sr)}></Button></div>
  //                             </div>
  //                             {isAdvanced ?
  //                             <div>
  //                                 <div style={{ display: 'flex', padding: '8px', justifyContent: 'space-between' }}>
  //                                     <div>
  //                                         <div>
  //                                             <label>Order By</label>
  //                                         </div>
  //                                         <div>
  //                                             <Select style={{ minWidth: '100px' }} value={sr.config.orderBy} onChange={(val) => handleChngeColumnOrderby(i, sr, val)}>
  //                                                 <Option>ASC</Option>
  //                                                 <Option>DESC</Option>
  //                                             </Select>
  //                                         </div>
  //                                     </div>
  //                                     <div>
  //                                         <div>
  //                                             <label>Sort By</label>
  //                                         </div>
  //                                         <div>
  //                                             <Select style={{ minWidth: '100px' }} onChange={(val) => handleChngeColumnSortby(i, sr, val)} >
  //                                                 {fieldNames.map(f => (
  //                                                     <Option value={f.fieldName}>{f.fieldName}</Option>
  //                                                 ))}
  //                                             </Select>
  //                                         </div>
  //                                     </div>
  //                                 </div>
  //                                 <div style={{padding:'8px'}}>
  //                                         <Checkbox onChange={(e) =>onChangeShowColumnTotals(i, sr, e.target.checked)} checked={sr.config.showTotals}>ShowTotal</Checkbox>
  //                                     </div>
  //                             </div>: null}
  //                         </div>

  //                     ))}
  //                 </div>
  //             </Col>
  //             {isAdvanced ?
  //                 <Col span={8}>
  //                     <div style={{ border: '1px solid #aaa' }}>
  //                         <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', alignItems: 'center' }}>
  //                             <div>Value</div>
  //                             <div>
  //                                 <AutoComplete
  //                                     // value={tempColumn.value || ''}
  //                                     options={fieldNames.filter(f => f.dataType === 'number')}
  //                                     filterOption={(inputValue, option) =>
  //                                         option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
  //                                     }
  //                                     style={{
  //                                         width: 140,
  //                                     }}
  //                                     onChange={(value) => { console.log("VAL+++>>", value) }}
  //                                     onSelect={(value, option) => { setTempValue(option) }}
  //                                     placeholder="Value"
  //                                 />
  //                             </div>
  //                             <Button onClick={handleAddValue}>Add</Button>
  //                         </div>

  //                         {selectedValues.map((sv, i) => (

  //                             <div style={{ margin: '8px', border: '1px solid #bbb' }} key={`sc_${i}`}>
  //                                 <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', allignItems: 'baseline' }}>
  //                                     <div>
  //                                         <b>{sv.fieldName}</b>
  //                                     </div>
  //                                     <div><Button type="link" icon={<CloseOutlined />} danger size="small" onClick={() => removeValues(sv)}></Button></div>
  //                                 </div>
  //                                 <div style={{ display: 'flex', padding: '8px', justifyContent: 'space-between' }}>
  //                                     <div>
  //                                         <div>
  //                                             <label>Function</label>
  //                                         </div>
  //                                         <div>
  //                                             <Select style={{ minWidth: '100px' }} onChange={(val) => handleChangeGroupFunc(val, i)}>
  //                                                 <Option value="sum">Sum</Option>
  //                                                 {/* <Option value="count">Count</Option>
  //                                                 <Option value="average">Average</Option>
  //                                                 <Option value="max">Max</Option>
  //                                                 <Option value="min">Min</Option> */}
  //                                             </Select>
  //                                         </div>
  //                                     </div>
  //                                     <div>
  //                                         <div>
  //                                             <label>Show As</label>
  //                                         </div>
  //                                         <div>
  //                                             <Select style={{ minWidth: '100px', maxWidth: '140px' }} onChange={(val) => handleChangeGroupShowAs(val.i)}>
  //                                                 <Option value="value">Value</Option>
  //                                                 <Option value="percentage_row">Percentage Of Row</Option>
  //                                                 <Option value="percentage_col">Percentage Of Column</Option>
  //                                                 <Option value="percentage_total">Percentage Total</Option>
  //                                             </Select>
  //                                         </div>
  //                                     </div>
  //                                 </div>
  //                             </div>
  //                         ))}
  //                     </div>
  //                     {/* <div style={{ border: '1px solid #aaa' }}>
  //                     <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', alignItems: 'center' }}>
  //                         <div>Values</div>
  //                         <div><Input /></div>
  //                         <Button onClick={handleAddColumn}>Add</Button>

  //                     </div>
  //                     <div style={{ margin: '8px', border: '1px solid #bbb', display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
  //                         <div>
  //                             <b>Field Name</b>
  //                         </div>
  //                         <div>X</div>
  //                     </div>
  //                 </div> */}
  //                 </Col>
  //                 : null}

  //             {/* <Col span={6}> */}
  //             {/* <div style={{border:'1px solid #aaa'}}>
  //                 <div style={{display:'flex', justifyContent:'space-between', padding:'8px', alignItems:'center'}}>
  //                     <div>Values</div>
  //                     <div><Input /></div>
  //                     <Button>Add</Button>

  //                 </div>
  //                 <div style={{margin: '8px', border:'1px solid #bbb', display:'flex', justifyContent:'space-between', padding:'8px'}}>
  //                         <div>
  //                             <b>Field Name</b>
  //                         </div>
  //                         <div>X</div>
  //                     </div>
  //             </div> */}
  //             {/* <DragDropContext onDragEnd={handleOnDragEnd}>
  //                     <Droppable droppableId='list'>
  //                         {(provided) => (
  //                             <div
  //                                 ref={provided.innerRef}
  //                                 {...provided.droppableProps}
  //                                 style={{ overflowY: "auto", height: "30vh", border: '1px solid red' }}
  //                             >
  //                                 {availableFields.filter(a => a.checked).map((af, index) => (
  //                                     <Draggable key={`draggable_${index}`} draggableId={af.id} index={index}>
  //                                         {(drprovided) => (
  //                                             <div
  //                                                 ref={drprovided.innerRef}
  //                                                 {...drprovided.draggableProps}
  //                                                 {...drprovided.dragHandleProps}
  //                                             >
  //                                                 <div style={{ padding: '12px', marginBottom: '12px', border: '1px solid #ccc' }}>
  //                                                     {af.fieldName}
  //                                                 </div>
  //                                             </div>
  //                                         )}
  //                                     </Draggable>
  //                                 ))}
  //                             </div>
  //                         )}
  //                     </Droppable>
  //                 </DragDropContext> */}
  //             {/* </Col> */}
  //         </Row>
  //     </div>
  // )

  //   return (
  //     <div className="grouping-wrapper">
  //       {/* Advanced Grouping toggle */}
  //       <div className="grouping-header">
  //         <Checkbox onChange={onChangeAdvancedGrouping} checked={isAdvanced}>
  //           Advanced Grouping
  //         </Checkbox>
  //       </div>

  //       {/* ── ROWS ── */}
  //       <div className="grouping-section">
  //         <label>Rows</label>
  //         <div className="grouping-field-box">
  //           <div className="grouping-field-box-header">
  //             <AutoComplete
  //               options={fieldNames}
  //               filterOption={(inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
  //               style={{ flex: 1 }}
  //               onChange={(value) => console.log("VAL+++>>", value)}
  //               onSelect={(value, option) => setTempRow(option)}
  //               placeholder="Search rows..."
  //             />
  //             <Button size="small" onClick={handleAddRow}>
  //               Add
  //             </Button>
  //           </div>

  //           {selectedRows.map((sr, i) => (
  //             <div key={`sr_${i}`}>
  //               <div className="grouping-field-item">
  //                 <b style={{ fontSize: "12px" }}>{sr.fieldName}</b>
  //                 <Button type="link" icon={<CloseOutlined />} danger size="small" onClick={() => removeRow(sr)} />
  //               </div>
  //               {isAdvanced ? (
  //                 <div className="grouping-advanced-grid">
  //                   <div className="grouping-advanced-field">
  //                     <label>Order By</label>
  //                     <Select
  //                       style={{ width: "100%" }}
  //                       value={sr.config.orderBy}
  //                       onChange={(val) => handleChngeRowOrderby(i, sr, val)}
  //                     >
  //                       <Option value="ASC">ASC</Option>
  //                       <Option value="DESC">DESC</Option>
  //                     </Select>
  //                   </div>
  //                   <div className="grouping-advanced-field">
  //                     <label>Sort By</label>
  //                     <Select style={{ width: "100%" }} onChange={(val) => handleChngeRowSortby(i, sr, val)}>
  //                       {fieldNames.map((f) => (
  //                         <Option key={f.fieldName} value={f.fieldName}>
  //                           {f.fieldName}
  //                         </Option>
  //                       ))}
  //                     </Select>
  //                   </div>
  //                   <div style={{ gridColumn: "1 / -1" }}>
  //                     <Checkbox
  //                       onChange={(e) => onChangeShowRowTotals(i, sr, e.target.checked)}
  //                       checked={sr.config.showTotals}
  //                     >
  //                       Show total
  //                     </Checkbox>
  //                   </div>
  //                 </div>
  //               ) : null}
  //             </div>
  //           ))}
  //         </div>
  //       </div>

  //       {/* ── COLUMNS ── */}
  //       <div className="grouping-section">
  //         <label>Columns</label>
  //         <div className="grouping-field-box">
  //           <div className="grouping-field-box-header">
  //             <AutoComplete
  //               options={isAdvanced ? fieldNames : fieldNames.filter((f) => f.dataType === "number")}
  //               filterOption={(inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
  //               style={{ flex: 1 }}
  //               onChange={(value) => console.log("VAL+++>>", value)}
  //               onSelect={(value, option) => setTempColumn(option)}
  //               placeholder="Search columns..."
  //             />
  //             <Button size="small" onClick={handleAddColumn}>
  //               Add
  //             </Button>
  //           </div>

  //           {selectedColumns.map((sr, i) => (
  //             <div key={`sc_${i}`}>
  //               <div className="grouping-field-item">
  //                 <b style={{ fontSize: "12px" }}>{sr.fieldName}</b>
  //                 <Button type="link" icon={<CloseOutlined />} danger size="small" onClick={() => removeColumn(sr)} />
  //               </div>
  //               {isAdvanced ? (
  //                 <div className="grouping-advanced-grid">
  //                   <div className="grouping-advanced-field">
  //                     <label>Order By</label>
  //                     <Select
  //                       style={{ width: "100%" }}
  //                       value={sr.config.orderBy}
  //                       onChange={(val) => handleChngeColumnOrderby(i, sr, val)}
  //                     >
  //                       <Option value="ASC">ASC</Option>
  //                       <Option value="DESC">DESC</Option>
  //                     </Select>
  //                   </div>
  //                   <div className="grouping-advanced-field">
  //                     <label>Sort By</label>
  //                     <Select style={{ width: "100%" }} onChange={(val) => handleChngeColumnSortby(i, sr, val)}>
  //                       {fieldNames.map((f) => (
  //                         <Option key={f.fieldName} value={f.fieldName}>
  //                           {f.fieldName}
  //                         </Option>
  //                       ))}
  //                     </Select>
  //                   </div>
  //                   <div style={{ gridColumn: "1 / -1" }}>
  //                     <Checkbox
  //                       onChange={(e) => onChangeShowColumnTotals(i, sr, e.target.checked)}
  //                       checked={sr.config.showTotals}
  //                     >
  //                       Show total
  //                     </Checkbox>
  //                   </div>
  //                 </div>
  //               ) : null}
  //             </div>
  //           ))}
  //         </div>
  //       </div>

  //       {/* ── VALUE (advanced only) ── */}
  //       {isAdvanced ? (
  //         <div className="grouping-section">
  //           <label>Value</label>
  //           <div className="grouping-field-box">
  //             <div className="grouping-field-box-header">
  //               <AutoComplete
  //                 options={fieldNames.filter((f) => f.dataType === "number")}
  //                 filterOption={(inputValue, option) =>
  //                   option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
  //                 }
  //                 style={{ flex: 1 }}
  //                 onChange={(value) => console.log("VAL+++>>", value)}
  //                 onSelect={(value, option) => setTempValue(option)}
  //                 placeholder="Search values..."
  //               />
  //               <Button size="small" onClick={handleAddValue}>
  //                 Add
  //               </Button>
  //             </div>

  //             {selectedValues.map((sv, i) => (
  //               <div key={`sv_${i}`}>
  //                 <div className="grouping-field-item">
  //                   <b style={{ fontSize: "12px" }}>{sv.fieldName}</b>
  //                   <Button type="link" icon={<CloseOutlined />} danger size="small" onClick={() => removeValues(sv)} />
  //                 </div>
  //                 <div className="grouping-advanced-grid">
  //                   <div className="grouping-advanced-field">
  //                     <label>Function</label>
  //                     <Select style={{ width: "100%" }} onChange={(val) => handleChangeGroupFunc(val, i)}>
  //                       <Option value="sum">Sum</Option>
  //                     </Select>
  //                   </div>
  //                   <div className="grouping-advanced-field">
  //                     <label>Show As</label>
  //                     <Select style={{ width: "100%" }} onChange={(val) => handleChangeGroupShowAs(val, i)}>
  //                       <Option value="value">Value</Option>
  //                       <Option value="percentage_row">% of Row</Option>
  //                       <Option value="percentage_col">% of Column</Option>
  //                       <Option value="percentage_total">% Total</Option>
  //                     </Select>
  //                   </div>
  //                 </div>
  //               </div>
  //             ))}
  //           </div>
  //         </div>
  //       ) : null}

  //       {/* ── ACTIONS ── */}
  //       <div className="grouping-actions">
  //         <Button type="primary" onClick={HandleApplyGrouping}>
  //           Apply
  //         </Button>
  //         <Button onClick={resetBuilders}>Reset</Button>
  //       </div>
  //     </div>
  //   );

  return (
    <div className="grouping-wrapper">
      {/* Advanced Grouping toggle */}
      <div className="grouping-header">
        <Checkbox onChange={onChangeAdvancedGrouping} checked={isAdvanced}>
          Advanced Grouping
        </Checkbox>
      </div>

      {/* ── ROWS ── */}
      <div className="grouping-section">
        <label>Rows</label>
        <div className="grouping-field-box">
          <div className="grouping-field-box-header">
            <Select
              style={{ flex: 1 }}
              placeholder="Select field"
              value={tempRow.value || undefined}
              onChange={(value, option) => setTempRow(option)}
              showSearch
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {fieldNames
                .filter((f) => !selectedRows.find((sr) => sr.fieldName === f.fieldName))
                .map((f) => (
                  <Option key={f.fieldName} value={f.fieldName}>
                    {f.fieldName}
                  </Option>
                ))}
            </Select>
            <Button size="small" onClick={handleAddRow}>
              Add
            </Button>
          </div>

          {/* Tags */}
          {selectedRows.length > 0 && (
            <div className="grouping-tags">
              {selectedRows.map((sr, i) => (
                <div key={`sr_${i}`} className={` ${isAdvanced ? "grouping-tags-wrapper-advanced" : ""}`}>
                  <span className="grouping-tag">
                    {sr.value}
                    <img
                      className="grouping-tag-remove"
                      onClick={() => removeRow(sr)}
                      src={CloseIcon}
                      alt="close-icon"
                    />
                  </span>
                  {isAdvanced ? (
                    <div className="grouping-advanced-grid">
                      <div className="grouping-advanced-field">
                        <label>Order By</label>
                        <Select
                          style={{ width: "100%" }}
                          value={sr.config.orderBy}
                          onChange={(val) => handleChngeRowOrderby(i, sr, val)}
                        >
                          <Option value="ASC">ASC</Option>
                          <Option value="DESC">DESC</Option>
                        </Select>
                      </div>
                      <div className="grouping-advanced-field">
                        <label>Sort By</label>
                        <Select style={{ width: "100%" }} onChange={(val) => handleChngeRowSortby(i, sr, val)}>
                          {fieldNames.map((f) => (
                            <Option key={f.fieldName} value={f.fieldName}>
                              {f.fieldName}
                            </Option>
                          ))}
                        </Select>
                      </div>
                      <div style={{ gridColumn: "1 / -1" }}>
                        <Checkbox
                          onChange={(e) => onChangeShowRowTotals(i, sr, e.target.checked)}
                          checked={sr.config.showTotals}
                        >
                          Show total
                        </Checkbox>
                      </div>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ── COLUMNS ── */}
      <div className="grouping-section">
        <label>Columns</label>
        <div className="grouping-field-box">
          <div className="grouping-field-box-header">
            <Select
              style={{ flex: 1 }}
              placeholder="Select field"
              value={tempColumn.value || undefined}
              onChange={(value, option) => setTempColumn(option)}
              showSearch
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {fieldNames
                .filter((f) => {
                  const typeOk = isAdvanced ? true : f.dataType === "number";
                  return typeOk && !selectedColumns.find((sc) => sc.fieldName === f.fieldName);
                })
                .map((f) => (
                  <Option key={f.fieldName} value={f.fieldName}>
                    {f.fieldName}
                  </Option>
                ))}
            </Select>
            <Button size="small" onClick={handleAddColumn}>
              Add
            </Button>
          </div>

          {selectedColumns.length > 0 && (
            <div className="grouping-tags">
              {selectedColumns.map((sr, i) => (
                <div key={`sc_${i}`} style={{ width: "100%" }}>
                  <span className="grouping-tag">
                    {sr.value}

                    <img
                      className="grouping-tag-remove"
                      onClick={() => removeColumn(sr)}
                      src={CloseIcon}
                      alt="close-icon"
                    />
                  </span>
                  {isAdvanced ? (
                    <div className="grouping-advanced-grid">
                      <div className="grouping-advanced-field">
                        <label>Order By</label>
                        <Select
                          style={{ width: "100%" }}
                          value={sr.config.orderBy}
                          onChange={(val) => handleChngeColumnOrderby(i, sr, val)}
                        >
                          <Option value="ASC">ASC</Option>
                          <Option value="DESC">DESC</Option>
                        </Select>
                      </div>
                      <div className="grouping-advanced-field">
                        <label>Sort By</label>
                        <Select style={{ width: "100%" }} onChange={(val) => handleChngeColumnSortby(i, sr, val)}>
                          {fieldNames.map((f) => (
                            <Option key={f.fieldName} value={f.fieldName}>
                              {f.fieldName}
                            </Option>
                          ))}
                        </Select>
                      </div>
                      <div style={{ gridColumn: "1 / -1" }}>
                        <Checkbox
                          onChange={(e) => onChangeShowColumnTotals(i, sr, e.target.checked)}
                          checked={sr.config.showTotals}
                        >
                          Show total
                        </Checkbox>
                      </div>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ── VALUE (advanced only) ── */}
      {isAdvanced ? (
        <div className="grouping-section">
          <label>Value</label>
          <div className="grouping-field-box">
            <div className="grouping-field-box-header">
              <Select
                style={{ flex: 1 }}
                placeholder="Select field"
                value={tempValue.value || undefined}
                onChange={(value, option) => setTempValue(option)}
                showSearch
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {fieldNames
                  .filter((f) => f.dataType === "number" && !selectedValues.find((sv) => sv.fieldName === f.fieldName))
                  .map((f) => (
                    <Option key={f.fieldName} value={f.fieldName}>
                      {f.fieldName}
                    </Option>
                  ))}
              </Select>
              <Button size="small" onClick={handleAddValue}>
                Add
              </Button>
            </div>

            {selectedValues.length > 0 && (
              <div className="grouping-tags">
                {selectedValues.map((sv, i) => (
                  <div key={`sv_${i}`}>
                    <span className="grouping-tag">
                      {sv.fieldName}
                      <img
                        className="grouping-tag-remove"
                        onClick={() => removeValue(sv)}
                        src={CloseIcon}
                        alt="close-icon"
                      />
                    </span>
                    <div className="grouping-advanced-grid">
                      <div className="grouping-advanced-field">
                        <label>Function</label>
                        <Select
                          style={{ width: "100%" }}
                          value={sv.config?.func || "sum"}
                          onChange={(val) => handleChangeGroupFunc(val, i)}
                        >
                          <Option value="sum">Sum</Option>
                          <Option value="count">Count</Option>
                          <Option value="average">Average</Option>
                        </Select>
                      </div>
                      <div className="grouping-advanced-field">
                        <label>Show As</label>
                        <Select
                          style={{ width: "100%" }}
                          value={sv.config?.showas || "value"}
                          onChange={(val) => handleChangeGroupShowAs(val, i)}
                        >
                          <Option value="value">Value</Option>
                          <Option value="percentage_row">% of Row</Option>
                          <Option value="percentage_col">% of Column</Option>
                          <Option value="percentage_total">% Total</Option>
                        </Select>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ) : null}

      {/* ── ACTIONS ──
          The old editor hid Apply until a Row AND a Column existed, because Rows are the
          group-by keys and Columns are the fields actually aggregated - without a Column
          the result carries no values. Same rule, shown as a disabled button. */}
      <div className="grouping-actions">
        <Button type="primary" onClick={HandleApplyGrouping} disabled={!canApplyGrouping}>
          Apply
        </Button>
        <Button onClick={resetBuilders}>Reset</Button>
      </div>

      {!canApplyGrouping ? <div className="grouping-hint">{applyHint}</div> : null}
    </div>
  );
}
